export const sanitizeString = (input: string | undefined) => {
  if (!input) return input
  // input = input.replace(/[^\w\s-]/g, "")
  input = input.toLowerCase()
  input = input.replace(/å/g, "a").replace(/ä/g, "a").replace(/ö/g, "o")
  input = input.trim().replace(/[\s]+/g, "-")

  return input
}
